import features from "shared/services/features";

export default ({ app }) => {
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$features = features;
};
